import styled from "styled-components/macro";
export const FormTitle = styled.div`
  font-weight: 200;
  margin-top: 0.6em;
`;
